import React from 'react';
import { Link } from '@nerdwallet/currency';

export default {
  people: [
    {
      name: 'Kimberly Palmer',
      firstName: 'Kimberly',
      title: '',
      blurb:
        'Personal finance, budgeting, banking, family finances, money saving strategies',
      description: '',
      education:
        'B.A. in History, Amherst College; M.P.P., University of Chicago',
      experience:
        'U.S. News & World Report, AARP, author of three personal finance books, including “The Economy of You” and “Smart Mom, Rich Mom”',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.today.com/video/on-the-money-start-today-129773125604">
            TODAY Show
          </Link>
          ,{' '}
          <Link href="https://abcnews.go.com/GMA/Travel/video/rental-car-alternatives-busy-holiday-weekend-84989053">
            Good Morning America
          </Link>
          ,{' '}
          <Link href="https://www.cbsnews.com/video/gas-prices-reach-new-record-high/">
            CBS News
          </Link>
          ,{' '}
          <Link href="https://www.wellandgood.com/mental-health-month-tips/">
            Well+Good
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/kim_lg.jpg',
      imageMobile: '/images/specialists/kim_sm.jpg',
      imageAlt: 'Kimberly Palmer',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/kimberlyspalmer/',
    },
    {
      name: 'Holden Lewis',
      firstName: 'Holden',
      title: '',
      blurb:
        'Mortgages, mortgage rates, housing market trends, home buying and selling, home renovations',
      description: '',
      education: 'B.A. in Journalism, University of North Texas',
      experience: 'Bankrate, Associated Press, Toledo Blade',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.washingtonpost.com/business/2022/04/07/mortgage-rates-keep-climbing-show-no-sign-slowing-down/">
            The Washington Post
          </Link>
          ,{' '}
          <Link href="https://www.businessinsider.com/americans-unlikely-lose-homes-foreclosure-real-estate-housing-bubble-bursts-2022-4">
            Insider
          </Link>
          ,{' '}
          <Link href="https://www.cnbc.com/2022/03/31/the-fed-may-get-more-aggressive-to-fight-inflation-how-to-prepare.html">
            CNBC
          </Link>
          ,{' '}
          <Link href="https://www.wsj.com/articles/mortgage-rates-are-still-low-heres-how-home-buyers-can-lock-in-rates-11646303402">
            The Wall Street Journal
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/holden_lg.jpg',
      imageMobile: '/images/specialists/holden_sm.jpg',
      imageAlt: 'Holden Lewis',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/holdenearllewis/',
    },
    {
      name: 'Sara Rathner',
      firstName: 'Sara',
      title: '',
      blurb: 'Credit cards, points/miles programs, general travel tips',
      description: '',
      education: 'B.S. in Journalism, Northwestern University',
      experience: 'The Motley Fool, The Washington Post',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.wsj.com/articles/credit-card-travel-perks-11648133850?mod=life_work_lead_pos1">
            The Wall Street Journal
          </Link>
          ,{' '}
          <Link href="https://www.cnbc.com/2022/01/11/amid-rising-prices-us-households-fall-deeper-in-debt.html">
            CNBC
          </Link>
          ,{' '}
          <Link href="https://www.usatoday.com/story/money/2022/04/19/inflation-gas-food-money-savings-tips/7323893001/">
            USA Today
          </Link>
          ,{' '}
          <Link href="https://www.realsimple.com/work-life/money/saving/debt-consolidation-mistakes">
            Real Simple
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/sara_lg.jpg',
      imageMobile: '/images/specialists/sara_sm.jpg',
      imageAlt: 'Sara Rathner',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/sara-klieger-rathner/',
    },
    {
      name: 'Elizabeth Renter',
      firstName: 'Elizabeth',
      title: '',
      blurb: 'Data trends, personal finance',
      description: '',
      education: 'B.S., Bellevue University',
      experience: 'Huffington Post, The Crime Report',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.nbc12.com/2022/05/16/ways-mitigtate-credit-card-use-during-inflation/">
            NBC Richmond
          </Link>
          ,{' '}
          <Link href="https://www.marketwatch.com/amp/picks/4-surprising-housing-markets-where-home-prices-have-actually-fallen-01646085699">
            MarketWatch
          </Link>
          ,{' '}
          <Link href="https://www.mpamag.com/us/mortgage-industry/industry-trends/nerdwallet-reveals-how-many-borrowers-failed-to-close-deal-last-year/324863">
            Mortgage Professional America
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/elizabeth_lg.jpg',
      imageMobile: '/images/specialists/elizabeth_sm.jpg',
      imageAlt: 'Elizabeth Renter',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/elizabethrenter/',
    },
    {
      name: 'Liz Weston, CFP®',
      firstName: 'Liz',
      title: '',
      blurb:
        'Personal finance, credit scores, debt management, retirement spending',
      description: '',
      education:
        'B.A. in Economics and Communications, Pacific Lutheran University',
      experience: 'MSN, Reuters, Los Angeles Times',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.checkbook.org/puget-sound-area/consumers-notebook/articles/Credit-Score-Myths-vs-Reality-Don-t-Let-These-Common-Misconceptions-Hold-You-Back-7635">
            Consumers’ Checkbook
          </Link>
          ,{' '}
          <Link href="https://www.king5.com/article/entertainment/television/programs/new-day-northwest/digital-assets-estate-planning-email-social-media-subscriptions-cryptocurrency/281-ea853ddc-a607-4d3b-bf55-018943afd842">
            NBC Seattle
          </Link>
          ,{' '}
          <Link href="https://podcasts.apple.com/us/podcast/9-to-your-credit-understanding-how-credit-scores-work/id1588774344?i=1000550666235">
            Consumerpedia Podcast
          </Link>
          ,{' '}
          <Link href="https://www.nerdwallet.com/blog/podcast/">
            Smart Money Podcast
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/liz_lg.jpg',
      imageMobile: '/images/specialists/liz_sm.jpg',
      imageAlt: 'Liz Weston',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/lizweston/',
    },
    {
      name: 'Sean Pyles',
      firstName: 'Sean',
      title: '',
      blurb: 'Debt payoff tips, debt management, debt relief',
      description: '',
      education: 'B.A. in Journalism, Magna Cum Laude, Marlboro College',
      experience: 'San Francisco Magazine, Windy City Times',
      featuredIn: (
        <React.Fragment>
          <Link href="https://abcnews.go.com/Lifestyle/wireStory/millennial-money-crafting-smarter-money-goals-2021-75338523">
            ABC News
          </Link>
          ,{' '}
          <Link href="https://www.nerdwallet.com/blog/podcast/">
            Smart Money Podcast
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/sean_lg.jpg',
      imageMobile: '/images/specialists/sean_sm.jpg',
      imageAlt: 'Sean Pyles',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/seanloranpyles/',
    },
    {
      name: 'Anna Helhoski',
      firstName: 'Anna',
      title: '',
      blurb:
        'Federal and private student loans, paying down student loan debt, college financial aid, scholarships',
      description: '',
      education:
        'B.A. in Journalism and Political Science, SUNY Purchase College',
      experience: 'The Daily Voice, The Legislative Gazette',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.cnbc.com/2020/05/28/student-loan-forgiveness-debate-continues-in-congress-and-debt-balances-rise.html">
            CNBC
          </Link>
          ,{' '}
          <Link href="https://www.newsweek.com/are-student-loan-payments-deferred-trump-executive-order-student-loans-explained-1524098">
            Newsweek
          </Link>
          ,{' '}
          <Link href="https://abcaudio.com/podcasts/_start-here/">
            ABC’s Start Here podcast
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/anna_lg.jpg',
      imageMobile: '/images/specialists/anna_sm.jpg',
      imageAlt: 'Anna Helhoski',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/annahelhoski/',
    },
    {
      name: 'Chanelle Bessette',
      firstName: 'Chanelle',
      title: '',
      blurb: 'Consumer banking, checking, cash management accounts',
      description: '',
      education:
        'B.A. in Journalism and B.A. in Linguistics, University of Nevada, Reno',
      experience: 'Fortune, Forbes, and the Reno Gazette-Journal',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.nytimes.com/2021/03/09/business/apps-personal-finance-budget.html">
            The New York Times
          </Link>
          ,{' '}
          <Link href="https://www.vox.com/22367985/paypal-venmo-financial-inequality-unbanked-underbanked">
            Vox
          </Link>
          ,{' '}
          <Link href="https://www.apartmenttherapy.com/reverse-overdraft-fees-script-36836141">
            Apartment Therapy
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/chanelle_lg.jpg',
      imageMobile: '/images/specialists/chanelle_sm.jpg',
      imageAlt: 'Chanelle Bessette',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/chanellebessette/',
    },
    {
      name: 'Kate Wood',
      firstName: 'Kate',
      title: '',
      blurb: 'Homebuying',
      description: '',
      education:
        'B.A. in Sociology from Vassar College, M.A. in Sociology from UC San Diego',
      experience: 'This Old House magazine',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.wsj.com/articles/four-ways-home-buyers-can-get-an-edge-in-a-cutthroat-sellers-market-11653695758?st=q8mxcfups5qcgkl&reflink=desktopwebshare_permalink">
            The Wall Street Journal
          </Link>
          ,{' '}
          <Link href="https://www.npr.org/2022/03/18/1087272336/americans-will-feel-the-impact-as-fed-raises-rates-heres-what-you-should-know">
            NPR
          </Link>
          ,{' '}
          <Link href="https://www.marketwatch.com/picks/this-is-the-no-1-thing-homebuyers-say-they-compromised-on-when-buying-a-new-home-01649872313">
            MarketWatch
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/katewood_lg.jpg',
      imageMobile: '/images/specialists/katewood_sm.jpg',
      imageAlt: 'Kate Wood',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/therealkatewood/',
    },
    {
      name: 'Sally French',
      firstName: 'Sally',
      title: '',
      blurb:
        'Travel credit cards and rewards, points/miles programs, general travel tips',
      description: '',
      education:
        'B.J. in photojournalism from University of Missouri, B.A. in German from University of Missouri',
      experience: 'The New York Times, MarketWatch, The Orange County Register',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.washingtonpost.com/travel/tips/travel-prices-rising-summer-vacation/">
            The Washington Post
          </Link>
          ,{' '}
          <Link href="https://www.thestreet.com/lifestyle/travel/your-next-plane-ride-will-cost-a-lot-more">
            The Street
          </Link>
          ,{' '}
          <Link href="https://www.travelweekly.com/Travel-News/Airline-News/Airline-loyalty-plans-are-going-green-but-will-new-options-bring-benefits">
            Travel Weekly
          </Link>
          ,{' '}
          <Link href="https://nptelegraph.com/business/investment/personal-finance/high-gas-prices-have-you-down-try-these-tips-to-save-at-the-pump/article_a080d246-bde8-5060-8d2e-174dca551341.html">
            PennyWise podcast
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/sallyfrench_lg.jpg',
      imageMobile: '/images/specialists/sallyfrench_sm.jpg',
      imageAlt: 'Sally French',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/sallyfrench/',
    },
    {
      name: 'Sam Kemmis',
      firstName: 'Sam',
      title: '',
      blurb:
        'Travel credit cards, airline and hotel loyalty programs, general travel tips',
      description: '',
      education:
        'B.A. in philosophy from Boston University, M.A. in biology from Binghamton University',
      experience: 'The Onion, MyTravelNerd',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.washingtonpost.com/travel/tips/services-skip-airport-lines/">
            The Washington Post
          </Link>
          ,{' '}
          <Link href="https://www.cnbc.com/2022/02/21/here-are-the-5-most-valuable-airline-and-hotel-rewards-programs.html">
            CNBC
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/samkemmis_lg.jpg',
      imageMobile: '/images/specialists/samkemmis_sm.jpg',
      imageAlt: 'Sam Kemmis',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/sam-kemmis-11a3773b/',
    },
    {
      name: 'Cecilia Clark',
      firstName: 'Cecilia',
      title: '',
      blurb:
        'Education financing products, veterans benefits, Student and graduate finances',
      description: '',
      education: 'B.A. in English, M.Ed. in teaching and learning',
      experience: 'Operations supervisor, U.S. Army officer',
      featuredIn: (
        <React.Fragment>
          <Link href="https://fortune.com/education/business/articles/2022/05/06/what-biden-could-be-planning-for-student-loan-forgiveness/">
            Fortune
          </Link>
          ,{' '}
          <Link href="https://www.forbes.com/sites/adamminsky/2021/09/14/parents-hope-for-student-loan-forgiveness-as-they-struggle-with-loan-debt/?sh=9dd0671750b0">
            Forbes
          </Link>
          ,{' '}
          <Link href="https://www.marketwatch.com/picks/my-husband-refuses-to-pay-my-student-loans-his-reason-i-took-out-the-loans-before-we-were-together-is-there-some-loophole-to-get-him-to-pay-01643839946">
            MarketWatch
          </Link>
          ,{' '}
          <Link href="https://www.wthr.com/article/money/whats-the-deal/student-loans-to-refinance-or-to-not-refinance/531-98e3ff54-33c1-4435-adb5-844e9ff92a37">
            WTHR13
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/ceciliaclark_lg.jpg',
      imageMobile: '/images/specialists/ceciliaclark_sm.jpg',
      imageAlt: 'Cecilia Clark',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/ceciliaclarkcomms/',
    },
    {
      name: 'Annie Millerbernd',
      firstName: 'Annie',
      title: '',
      blurb: 'Personal loans, "buy now, pay later" loans, cash advance apps',
      description: '',
      education: 'B.A. in journalism from University of Minnesota',
      experience:
        'Reporter, The Press-Enterprise; data reporter, The San Antonio Express-News; digital content specialist, USAA',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.consumeraffairs.com/news/apple-steps-into-bnpl-with-introduction-of-apple-pay-later-060722.html">
            Consumer Affairs
          </Link>
          ,{' '}
          <Link href="https://www.marketwatch.com/picks/personal-loan-companies-are-advertising-rates-starting-below-5-tempting-but-heres-what-not-to-use-a-personal-loan-for-01649878368">
            MarketWatch
          </Link>
          ,{' '}
          <Link href="https://www.parents.com/parenting/money/family-finances/pros-and-cons-of-installment-payment-apps/">
            Parents
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/anniemillerbernd_lg.jpg',
      imageMobile: '/images/specialists/anniemillerbernd_sm.jpg',
      imageAlt: 'Annie Millerbernd',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/annie-millerbernd-8056b0a3/',
    },
    {
      name: 'Alana Benson',
      firstName: 'Alana',
      title: '',
      blurb:
        'Socially responsible and ESG investing, cryptocurrency, mutual funds, HSAs and financial advice',
      description: '',
      education:
        'Dual B.A. in English and classical civilizations from the University of Vermont',
      experience: 'LexisNexis, Rosen Publishing, Lander Journal',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.marketwatch.com/amp/picks/ive-found-that-a-financial-adviser-can-easily-cost-5-000-a-year-is-paying-an-adviser-really-worth-this-kind-of-money-01654024494">
            MarketWatch
          </Link>
          ,{' '}
          <Link href="https://www.the-sun.com/money/5127106/six-tax-tips-to-avoid-filing-last-minute/">
            The U.S. Sun
          </Link>
          ,{' '}
          <Link href="https://open.spotify.com/episode/4mlDL0fRCU615M7MzXg5M3">
            PennyWise Podcast
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/alanabenson_lg.jpg',
      imageMobile: '/images/specialists/alanabenson_sm.jpg',
      imageAlt: 'Alana Benson',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/alana-benson/',
    },
    {
      name: 'Andy Rosen',
      firstName: 'Andy',
      title: '',
      blurb: 'Cryptocurrency investing and alternative assets',
      description: '',
      education:
        'B.A. in journalism from University of Massachusetts Amherst, Graduate certificate in digital media production from University of Baltimore',
      experience: 'The Boston Globe, The Baltimore Sun',
      featuredIn: (
        <React.Fragment>
          <Link href="https://komonews.com/news/consumer/are-there-taxes-on-cryptocurrency-investments">
            KOMO News
          </Link>
          ,{' '}
          <Link href="https://www.marketwatch.com/picks/i-get-the-impression-hes-a-maga-hat-wearing-republican-and-im-pretty-liberal-this-concerns-me-should-my-financial-adviser-have-similar-beliefs-to-mine-01648782490">
            MarketWatch
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/andyrosen_lg.jpg',
      imageMobile: '/images/specialists/andyrosen_sm.jpg',
      imageAlt: 'Andy Rosen',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/andyrosen44/',
    },
    {
      name: 'Ben Moore',
      firstName: 'Ben',
      title: '',
      blurb: 'Auto and home insurance',
      description: '',
      education: 'B.S. in marketing, Olivet Nazarene University',
      experience: 'LendingTree',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.nbc12.com/2022/01/11/number-one-insurance-claims-filed-by-homeowners-winter/">
            NBC Richmond
          </Link>
          ,{' '}
          <Link href="https://open.spotify.com/episode/0Gx2YWlFJvKd3ZK2AceBxs">
            PennyWise Podcast
          </Link>
          ,{' '}
          <Link href="https://www.marketwatch.com/picks/could-you-be-paying-40-less-for-your-car-insurance-maybe-20-ways-to-save-money-on-car-insurance-now-01635264673">
            MarketWatch
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/benmoore_lg.jpg',
      imageMobile: '/images/specialists/benmoore_sm.jpg',
      imageAlt: 'Ben Moore',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/benmoore7/',
    },
    {
      name: 'Katia Iervasi',
      firstName: 'Katia',
      title: '',
      blurb: 'Life insurance',
      description: '',
      education: 'B.A. in communication from Griffith University',
      experience: 'Finder',
      featuredIn: '',
      image: '/images/specialists/katia_lg.jpg',
      imageMobile: '/images/specialists/katia_sm.jpg',
      imageAlt: 'Katia Iervasi',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/katia-iervasi-923531134/',
    },
    {
      name: 'Kate Ashford',
      firstName: 'Kate',
      title: '',
      blurb: 'Medicare',
      description: '',
      education:
        'B.A. in sociology from University of Virginia, M.S. in journalism, Northwestern University',
      experience: 'BBC, Forbes, Money, AARP',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.singlecare.com/blog/what-is-medicare-advantage/">
            SingleCare
          </Link>
          ,{' '}
          <Link href="https://www.healthline.com/health-news/medicare-upgrades-biden-plan-would-enhance-dental-vision-and-drug-price-coverage">
            Healthline
          </Link>
          ,{' '}
          <Link href="https://www.realsimple.com/work-life/money/saving/save-money-on-prescription-drugs">
            Real Simple
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/kateashford_lg.jpg',
      imageMobile: '/images/specialists/kateashford_sm.jpg',
      imageAlt: 'Kate Ashford',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/kateashford/',
    },
    {
      name: 'Kelsey Sheehy',
      firstName: 'Kelsey',
      title: '',
      blurb:
        'Small-business lending, banking and credit cards; business insurance, business software, and general small-business topics, personal finance',
      description: '',
      education:
        'M.S. in journalism from Northwestern University, B.A. in journalism from University of Iowa',
      experience: 'US News & World Report',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.consumeraffairs.com/news/small-businesses-are-struggling-to-pay-credit-card-swipe-fees-021822.html">
            Consumer Affairs
          </Link>
          ,{' '}
          <Link href="https://www.menshealth.com/trending-news/a38571253/quitting-9-to-5-job/">
            Men’s Health
          </Link>
          ,{' '}
          <Link href="https://www.latimes.com/business/story/2021-05-26/amid-covid-recovery-how-does-ppp-loan-forgiveness-work">
            Los Angeles Times
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/kelsey_lg.jpg',
      imageMobile: '/images/specialists/kelsey_sm.jpg',
      imageAlt: 'Kelsey Sheehy',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/kelseysheehy/',
    },
    {
      name: 'Randa Kriss',
      firstName: 'Randa',
      title: '',
      blurb:
        'Small-business lending, banking and credit cards; business insurance, business software, and general small-business topics',
      description: '',
      education: 'B.A. in English and Spanish from Iona College',
      experience: 'Fundera',
      featuredIn: (
        <React.Fragment>
          <Link href="https://www.bizjournals.com/bizjournals/news/2022/04/27/inflation-covid-labor-small-busines-congress.html">
            The Business Journals
          </Link>
          ,{' '}
          <Link href="https://www.kiro7.com/news/local/popular-side-hustles-used-make-extra-money/Z3HOQ3ZESRFGPGGBCLAYUG65EI/">
            KIRO 7
          </Link>
        </React.Fragment>
      ),
      image: '/images/specialists/randa_lg.jpg',
      imageMobile: '/images/specialists/randa_sm.jpg',
      imageAlt: 'Randa Kriss',
      specialties: '',
      twitterLink: '',
      linkedInLink: 'https://www.linkedin.com/in/mirandakriss/',
    },
  ],
};
